import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import ProfileActions from '../../redux/actions/profile';

import AuthService from '../../services/authService';

import Header from './Header';
import Menu from './Menu';
import Footer from '../../components/StickyMenu/Footer';


const Main = ({
  children,
  className,
  footerClassName,
  hasHeader,
  hasFooter,
  classNameHeader,
  canGoBack,
  showHeaderLogoMobile,
  showBreadcrumbsDesktop,
  onSubmitFilling,
  onSubmitDrilling,
  onSubmitDrillingPear,
  onSubmitFasteningElement,
}) => {
  const { i18n } = useTranslation();
  const dispatch = useDispatch();
  const userId = AuthService.getUserId();
  const { language } = useSelector(({ profile }) => profile);
  const storageLanguage = localStorage.getItem('language');

  useEffect(() => {
    if (userId) {
      dispatch(ProfileActions.getUserProfileRequest());
    }
  }, [i18n.language]);

  useEffect(() => {
    i18n.changeLanguage(userId ? language : storageLanguage);
  }, [userId, language]);

  return (
    <div className="main-wrapper">
      {!hasHeader || (
        <>
          <Header
            canGoBack={canGoBack}
            className={classNameHeader}
            showHeaderLogoMobile={showHeaderLogoMobile}
            showBreadcrumbsDesktop={showBreadcrumbsDesktop}
          />
          <Menu />
        </>
      )}

      <div className={clsx('main-wrapper--inner', className)}>
        <main
          className="page--main"
          role="main"
        >
          <div className="page--main-inner">
            {children}
          </div>
        </main>
      </div>

      {!hasFooter || (
        <Footer
          className={footerClassName}
          onSubmitFilling={onSubmitFilling}
          onSubmitDrilling={onSubmitDrilling}
          onSubmitDrillingPear={onSubmitDrillingPear}
          onSubmitFasteningElement={onSubmitFasteningElement}
        />
      )}
    </div>
  );
};

Main.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.func,
    PropTypes.node,
    PropTypes.object,
  ]),
  className: PropTypes.string,
  footerClassName: PropTypes.string,
  hasHeader: PropTypes.bool,
  hasFooter: PropTypes.bool,
  canGoBack: PropTypes.bool,
  showHeaderLogoMobile: PropTypes.bool,
  showBreadcrumbsDesktop: PropTypes.bool,
  classNameHeader: PropTypes.string,
  onSubmitFilling: PropTypes.func,
  onSubmitDrilling: PropTypes.func,
  onSubmitDrillingPear: PropTypes.func,
  onSubmitFasteningElement: PropTypes.func,
};

Main.defaultProps = {
  children: null,
  className: null,
  footerClassName: null,
  hasHeader: true,
  hasFooter: true,
  canGoBack: true,
  showHeaderLogoMobile: false,
  showBreadcrumbsDesktop: false,
  classNameHeader: '',
  onSubmitFilling: () => { },
  onSubmitDrilling: () => { },
  onSubmitDrillingPear: () => { },
  onSubmitFasteningElement: () => { },
};

export default Main;
